import {changeRateStore} from '@store/settings/changeRate/change-rate.store';
import APIAxios, {APIRoutes} from '@api/axios.api';
import {catchError, from, map, tap} from 'rxjs';
import {AxiosError, AxiosResponse} from 'axios';
import SnackError from '@utils/error.utils';
import {ChangeRate, ChangeRatePeriod} from '@store/settings/changeRate/change-rate.model';
import {getContainersDataSource} from '@store/settings/containers';
import {setEntities} from '@ngneat/elf-entities';
import {getChangeRateDataSource} from '@store/settings/changeRate/change-rate.requests';

export class ChangeRateService {
  store = changeRateStore;

  getRatePeriods = () => {
    return from(APIAxios({
      ...APIRoutes.GETChangeRatePeriods(),
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<ChangeRatePeriod[]>) => {
          console.log(response.data);
          return response.data;
        })
      );
  };

  getChangeRates = (period: Date) => {
    return from(APIAxios({
      ...APIRoutes.GETChangeRate(),
      params: {
        periodStart: period,
      }
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<ChangeRate[]>) => {
          return response.data;
        }),
        tap((changeRates) => {
          this.store.update(
            setEntities(changeRates),
            getChangeRateDataSource.setSuccess(),
          );
        }),
        getContainersDataSource.trackRequestStatus(),
      );
  };
}

export const changeRateService = new ChangeRateService();
